<template>
  <lr-dialog dialogTitle="个人信息" :dialogVisible.sync="visible" width="600px" 
        :closeSubmit="true">
    <user-detail  :UserID="UserID"></user-detail>
  </lr-dialog>
</template>

<script>
import UserDetail from "./UserDetail.vue";

export default {
  components: { UserDetail },
  name: "UserDetailDialog",
  props: {
    UserID: { type: String, required: true },
    showUserDetail: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(value) {
      if (!value) {
        this.$emit("update:showUserDetail", value);
      }
    },
  },
  mounted() {},
  data() {
    return {   visible: true,};
  },
  methods: {},
};
</script>




// WEBPACK FOOTER //
// src/components/User/UserDetailDialog.vue